const RegisterPage = () => {
    return (
      <div>
        <h3>RegisterPage</h3>
      </div>
    );
  };

  export default RegisterPage;